import React from 'react';
import '../App.css';
import PropTypes from 'prop-types';
/**
 * Component that displays the list of Product Collections.
 * Ex. 3ds Max, Cinema4D
 *
 * @param {Function} setSelectedCollection function for setting the selected
 * collection
 * @param {Array<object>} collections array of objects containing collection
 * information (title, description, image, id)
 * @return {Component}
 */
function CollectionList({setSelectedCollection, collections}) {
  return (
    <div className="content-container">
      <h1 className="content-container-section-name">Usage Based Licensing</h1>
      <p className="content-container-text">
        Usage Based Licensing purchases are no longer available.
      </p>
    </div>
  );
}

CollectionList.propTypes = {
  setSelectedCollection: PropTypes.func,
  collections: PropTypes.array,
};

export default CollectionList;
